import HoverCard from "@ch/components/HoverCard/HoverCard";
import HoverCardContent from "@ch/components/HoverCard/HoverCardContent";
import HoverCardTrigger from "@ch/components/HoverCard/HoverCardTrigger";
import { type FC, useState } from "react";
import type { KemCitationResource } from "../utils/types";
import KemCitationPill from "./KemCitationPill";
import KemCitationPopover from "./KemCitationPopover";

export interface KemCitationSourcesProps {
  resources: KemCitationResource[];
}

const KemCitationSources: FC<KemCitationSourcesProps> = ({ resources }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (resources.length === 0) {
    return null;
  }

  return (
    <div className="flex justify-end">
      <HoverCard onOpenChange={setIsOpen}>
        <HoverCardTrigger asChild>
          <KemCitationPill />
        </HoverCardTrigger>
        <HoverCardContent
          align="end"
          className="w-[280px] rounded-xl border-0 p-4 shadow-xl md:w-[320px]"
          side="top"
        >
          <KemCitationPopover isOpen={isOpen} resources={resources} />
        </HoverCardContent>
      </HoverCard>
    </div>
  );
};

export default KemCitationSources;
